!(function(e) {
  var t,
    n,
    c,
    o,
    i,
    l,
    a,
    d =
      '<svg><symbol id="icon-shenfenzheng" viewBox="0 0 1024 1024"><path d="M895.712 74.672 127.952 74.672C57.28 74.672 0 131.952 0 202.624l0 614.192c0 70.72 57.28 127.968 127.968 127.968l767.76 0c70.688 0 127.952-57.248 127.952-127.968L1023.68 202.624C1023.664 131.952 966.4 74.672 895.712 74.672L895.712 74.672zM972.48 816.816c0 42.4-34.384 76.784-76.768 76.784L127.952 893.6c-42.384 0-76.784-34.368-76.784-76.784L51.168 202.624c0-42.384 34.4-76.768 76.784-76.768l767.76 0c42.368 0 76.768 34.384 76.768 76.768L972.48 816.816 972.48 816.816zM153.552 714.464l281.504 0 0-51.184L153.552 663.28 153.552 714.464 153.552 714.464zM153.552 535.312l281.504 0 0-51.184L153.552 484.128 153.552 535.312 153.552 535.312zM153.552 356.176l281.504 0 0-51.184L153.552 304.992 153.552 356.176 153.552 356.176zM772.976 530.432c27.84-23.472 45.968-58.176 45.968-97.488 0-70.672-57.28-127.968-127.952-127.968-70.688 0-127.968 57.28-127.968 127.968 0 39.312 18.112 74.016 45.968 97.488-57.488 29.84-97.152 89.216-97.152 158.4 0 14.16 11.456 25.632 25.584 25.632s25.6-11.472 25.6-25.632c0-70.656 57.28-127.936 127.968-127.936 70.672 0 127.952 57.28 127.952 127.936 0 14.16 11.472 25.632 25.6 25.632s25.6-11.472 25.6-25.632C870.128 619.664 830.448 560.288 772.976 530.432L772.976 530.432zM690.992 509.728c-42.384 0-76.8-34.4-76.8-76.768s34.4-76.768 76.8-76.768c42.352 0 76.768 34.4 76.768 76.768S733.344 509.728 690.992 509.728L690.992 509.728zM690.992 509.728"  ></path></symbol><symbol id="icon-shijian" viewBox="0 0 1024 1024"><path d="M512 858.688A347.072 347.072 0 0 1 165.312 512 347.072 347.072 0 0 1 512 165.312 347.072 347.072 0 0 1 858.688 512 347.072 347.072 0 0 1 512 858.688zM512 96A416.448 416.448 0 0 0 96 512c0 229.376 186.624 416 416 416s416-186.624 416-416S741.376 96 512 96z m34.688 409.344V304a34.688 34.688 0 0 0-69.376 0v215.68a34.56 34.56 0 0 0 10.176 24.512l116.224 116.224a34.56 34.56 0 0 0 49.024 0 34.688 34.688 0 0 0 0-49.024L546.688 505.344z"  ></path></symbol><symbol id="icon-paizhao" viewBox="0 0 1024 1024"><path d="M896.4 188.4H801L769.2 125c-18.8-36.9-28.5-48.2-63.6-48.2H323.9c-35.1 0-46.7 15.1-63.6 48.2l-31.8 63.4h-95.4c-70.3 0-127.2 56.7-127.2 126.7v507c0 70 57 126.8 127.2 126.8h763.3c70.3 0 127.2-56.7 127.2-126.8v-507c0-70-56.9-126.7-127.2-126.7zM960 829.7c0 35-28.5 63.4-63.6 63.4H133.1c-35.1 0-63.6-28.4-63.6-63.4v-507c0-35 28.5-63.4 63.6-63.4h127.2l31.8-63.4c22.5-36.9 28.5-63.4 63.6-63.4h318c35.1 0 41.1 26.5 63.6 63.4l31.8 63.4h127.2c35.1 0 63.6 28.4 63.6 63.4l0.1 507z m0 0"  ></path><path d="M514.8 298.1c-140.5 0-254.4 113.5-254.4 253.5s113.9 253.5 254.4 253.5 254.4-113.5 254.4-253.5-113.9-253.5-254.4-253.5z m0 443.6c-105.4 0-190.8-85.1-190.8-190.1s85.4-190.1 190.8-190.1 190.8 85.1 190.8 190.1-85.5 190.1-190.8 190.1z m0 0"  ></path></symbol><symbol id="icon-zhanghu" viewBox="0 0 1024 1024"><path d="M511.925379 589.44903a294.720212 294.720212 0 1 1 294.720213-294.49767 295.016936 295.016936 0 0 1-294.720213 294.49767z m0-530.095806A235.375594 235.375594 0 1 0 747.300973 294.95136 235.598136 235.598136 0 0 0 511.925379 59.427404z" fill="" ></path><path d="M946.476349 1024a29.672309 29.672309 0 0 1-29.672309-29.672309 404.84157 404.84157 0 0 0-809.683141 0 29.672309 29.672309 0 0 1-59.344618 0 464.186189 464.186189 0 0 1 928.372378 0 29.672309 29.672309 0 0 1-29.67231 29.672309z" fill="" ></path></symbol></svg>',
    s = (t = document.getElementsByTagName('script'))[
      t.length - 1
    ].getAttribute('data-injectcss');
  if (s && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;
    try {
      document.write(
        '<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>'
      );
    } catch (e) {
      console && console.log(e);
    }
  }
  function h() {
    l || ((l = !0), o());
  }
  (n = function() {
    var e,
      t,
      n,
      c,
      o,
      i = document.createElement('div');
    (i.innerHTML = d),
      (d = null),
      (e = i.getElementsByTagName('svg')[0]) &&
        (e.setAttribute('aria-hidden', 'true'),
        (e.style.position = 'absolute'),
        (e.style.width = 0),
        (e.style.height = 0),
        (e.style.overflow = 'hidden'),
        (t = e),
        (n = document.body).firstChild
          ? ((c = t), (o = n.firstChild).parentNode.insertBefore(c, o))
          : n.appendChild(t));
  }),
    document.addEventListener
      ? ~['complete', 'loaded', 'interactive'].indexOf(document.readyState)
        ? setTimeout(n, 0)
        : ((c = function() {
            document.removeEventListener('DOMContentLoaded', c, !1), n();
          }),
          document.addEventListener('DOMContentLoaded', c, !1))
      : document.attachEvent &&
        ((o = n),
        (i = e.document),
        (l = !1),
        (a = function() {
          try {
            i.documentElement.doScroll('left');
          } catch (e) {
            return void setTimeout(a, 50);
          }
          h();
        })(),
        (i.onreadystatechange = function() {
          'complete' == i.readyState && ((i.onreadystatechange = null), h());
        }));
})(window);
